//import * as jquery from '../../../node_modules/jquery/dist/jquery.js';
import jquery from 'jquery';

// Create global references
window.$ = window.jQuery = jquery;

// Export for module usage
export default jquery;
export { jquery as jQuery };